function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), React.createElement("path", {
  fill: "currentColor",
  d: "M16.482 7.965a1.287 1.287 0 01.063 2.014l-5.378 4.69a1.371 1.371 0 01-1.897-.106 1.276 1.276 0 01.09-1.837l2.775-2.419H2.337C1.598 10.307 1 9.727 1 9c0-.722.608-1.307 1.337-1.307h9.798L9.36 5.274a1.276 1.276 0 01-.09-1.837 1.371 1.371 0 011.897-.106l5.315 4.634z"
})));